import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { Grid } from "@mui/material/";
import CleansingMenu from "../Products/Product/Menu/CleansingMenu";
import { useLocation } from "react-router-dom";
import TextField from "@mui/material/TextField";
import Rating from "@mui/material/Rating";
import Typography from "@mui/material/Typography";
import Alert from "@mui/material/Alert";
import { HashLink } from "react-router-hash-link";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import { makeStyles } from "@mui/styles";
import { useAuth } from "../../context/AuthContext";
import { useProductContext } from "../../context/ProductContext";
import Fade from "react-reveal/Fade";
// import {
//   db,
//   doc,
//   getDoc,
//   where,
//   getDocs,
//   query,
//   collection,
// } from "../../firebase";
import LeftMenu from "./LeftMenu";
import Review from "./Review";
import { useTranslation } from "react-i18next";

import {
  storage,
  ref,
  uploadBytes,
  uploadBytesResumable,
  getDownloadURL,
  deleteObject,
  addDoc,
  collection,
  db,
  serverTimestamp,
  deleteDoc,
  doc,
  setDoc,
  getDoc,
} from "../../firebase";
// import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";

const useStyles = makeStyles({
  body: { backgroundColor: "white", minHeight: "500px", padding: "50px" },
  title: { fontSize: "30px" },
});

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const DashboardLeaveANewReview = () => {
  const { t, i18n } = useTranslation();
  const classes = useStyles();

  const [value, setValue] = React.useState(5);

  const [open, setOpen] = React.useState(false);
  const [open2, setOpen2] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClickOpen2 = () => {
    setOpen2(true);
  };

  const handleClose2 = () => {
    setOpen2(false);
  };

  const [imageUrl, setImageUrl] = useState(undefined);
  const [imageUrl2, setImageUrl2] = useState(undefined);
  const [imageUrl3, setImageUrl3] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState(null);
  const [title, setTitle] = useState(null);
  const [comment, setComment] = useState(null);
  const { currentUser } = useAuth();
  let navigate = useNavigate();

  const [review, setReview] = useState(null);
  console.log("#### review ### ", review);

  let query = useQuery();
  let name = query.get("name");
  let link = query.get("link");
  let productId = query.get("productId");
  let id = query.get("id");

  console.log("id", id);

  const deleteReview = async () => {
    const reviewDb = "KO_" + "reviews_" + productId;
    await deleteDoc(doc(db, reviewDb, id));

    const userRef = doc(db, "users", currentUser.uid);
    const docSnap = await getDoc(userRef);

    if (docSnap.exists()) {
      let list = docSnap.data().reviews;
      console.log(list);
      console.log("id", reviewDb);
      // get the index of the id
      const index = list.indexOf(reviewDb);
      if (index > -1) {
        list.splice(index, 1); // 2nd parameter means remove one item only
      }

      setDoc(userRef, { reviews: list }, { merge: true });
      navigate(`/product/${link}#top`);
    } else {
      // navigate(`/product/${link}#top`);
    }
  };

  //   useEffect(() => {
  // const getDocFromDB = async () => {
  //   const reviewDb = "reviews_" + productId;
  //   const docRef = doc(db, reviewDb, id);
  //   const docSnap = await getDoc(docRef);
  //   if (docSnap.exists()) {
  //     setReview({ id: docSnap.id, ...docSnap.data() });
  //   } else {
  //     // navigate(`/product/${link}#top`);
  //   }
  // };
  // getDocFromDB();
  //   }, []);

  useEffect(() => {
    if (review) {
      setValue(review.rating);
      setTitle(review.title);
      setComment(review.comment);
      console.log(review.images);
      if (review.images) {
        if (review.images[0]) {
          setImageUrl(review.images[0]);
        }
        if (review.images[1]) {
          setImageUrl2(review.images[1]);
        }
        if (review.images[2]) {
          setImageUrl3(review.images[2]);
        }
      }
    }
  }, [setReview, review]);

  const removeImage = (url) => {
    // Create a reference to the file to delete
    const desertRef = ref(storage, url);

    // Delete the file
    deleteObject(desertRef)
      .then(() => {
        if (url === imageUrl) {
          setImageUrl(undefined);
        } else if (url === imageUrl2) {
          setImageUrl2(undefined);
        } else {
          setImageUrl3(undefined);
        }
      })
      .catch((error) => {
        // Uh-oh, an error occurred!
      });
  };

  const upload = async (fileName) => {
    setLoading(true);
    const random = Math.floor(Math.random() * 100000000000000);
    const path = productId + "/";

    const storageRef = ref(storage, path + random);

    const uploadTask = uploadBytesResumable(storageRef, fileName);

    // Register three observers:
    // 1. 'state_changed' observer, called any time the state changes
    // 2. Error observer, called on failure
    // 3. Completion observer, called on successful completion
    await uploadTask.on(
      "state_changed",
      (snapshot) => {
        // Observe state change events such as progress, pause, and resume
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log("Upload is " + progress + "% done");
        switch (snapshot.state) {
          case "paused":
            console.log("Upload is paused");
            break;
          case "running":
            console.log("Upload is running");
            break;
        }
      },
      (error) => {
        // Handle unsuccessful uploads
      },
      () => {
        // Handle successful uploads on complete
        // For instance, get the download URL: https://firebasestorage.googleapis.com/...
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          // if (
          //   imageUrl !== undefined &&
          //   imageUrl2 !== undefined &&
          //   imageUrl3 !== undefined
          // ) {
          //   alert("Maximum number of photo is 3.");
          // }
          if (imageUrl === undefined) {
            setImageUrl(downloadURL);
          } else if (imageUrl2 === undefined) {
            setImageUrl2(downloadURL);
          } else if (imageUrl3 === undefined) {
            setImageUrl3(downloadURL);
          } else {
            setAlert("Maximum number of photo is 3.");
          }

          console.log("File available at", downloadURL);
        });
      }
    );
    setLoading(false);
  };
  const goToAll = () => {
    ///dashboard-review
    navigate("/dashboard-review");
  };

  const submit = async (e) => {
    e.preventDefault();
    console.log(value); // rating

    //timestamp: serverTimestamp()
    if (title && comment) {
      // Add a new document with a generated id.
      const dbName = "KO_" + "reviews_" + productId;

      let fn = "";
      let ln = "";
      let firstCharacterOfFirstname;

      const userRef = doc(db, "users", currentUser.uid);
      const docSnap = await getDoc(userRef);

      if (docSnap.exists()) {
        fn = docSnap.data().firstname;
        firstCharacterOfFirstname = fn.charAt(0);
        ln = docSnap.data().lastname;

        let data;
        if (docSnap.data().reviews) {
          data = docSnap.data().reviews;
          console.log("======= data", data);
          data.push(dbName);
        } else {
          data = [dbName];
        }

        console.log("currentUser.uid", currentUser.uid);

        const userRef = doc(db, "users", currentUser.uid);
        setDoc(userRef, { reviews: data }, { merge: true });
      } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
      }

      // put review to review db

      let images = [];
      if (imageUrl !== undefined) {
        images.push(imageUrl);
      }
      if (imageUrl2 !== undefined) {
        images.push(imageUrl2);
      }
      if (imageUrl3 !== undefined) {
        images.push(imageUrl3);
      }

      const docRef = await addDoc(collection(db, dbName), {
        title: title,
        comment: comment,
        rating: value,
        created: serverTimestamp(),
        images: images,
        uid: currentUser.uid,
        name: currentUser.email,
        type: "original",
      });
      console.log("Document written with ID: ", docRef.id);

      handleClickOpen2(true);
      window.scrollTo(0, 0);
    }
  };
  return (
    <Grid
      container
      sx={{
        px: { md: 10, sm: 5 },
        pt: 7,
        pb: 20,
        backgroundColor: "#eceff1",
      }}
    >
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {t("Are you sure you want to delete this review?")}
        </DialogTitle>

        <DialogActions>
          <Button onClick={handleClose}>{t("Cancel")}</Button>
          <Button onClick={deleteReview} autoFocus>
            {t("Delete")}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={open2}
        onClose={handleClose2}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {t("The review is added successfully.")}
          <Box sx={{ display: "flex" }}>
            <button
              onClick={goToAll}
              className="custom_btn"
              style={{ margin: "20px", width: "400px" }}
            >
              {t("All my reviews")}
            </button>

            <button
              className="custom_btn_whitebg"
              style={{ margin: "20px", width: "400px" }}
              onClick={handleClose2}
            >
              {t("Stay in this page")}
            </button>
          </Box>
        </DialogTitle>
      </Dialog>

      <Grid item sm={12} md={12} sx={{ fontSize: "19px", pb: 2, pl: 2 }}>
        <Box>{t("MY ACCOUNT")}</Box>
      </Grid>

      <LeftMenu cursor="review" />
      <Grid md={9} sm={12} className={classes.body}>
        <Box className={classes.title}>
          <Box sx={{ fontSize: "16px", fontWeight: 600 }}>
            {t("Add a review")}
          </Box>
          <HashLink to="/dashboard-review">
            <Box
              sx={{
                fontSize: "13px",
                pt: 2,
                display: "flex",
                alignItems: "center",
              }}
            >
              <KeyboardBackspaceIcon
                sx={{ position: "relative", top: "-2px", pr: 1 }}
              />
              {t("Go Back To All My Reviews")}
            </Box>
          </HashLink>
          <Box
            sx={{ pt: 5, fontSize: "16px", fontWeight: 600, color: "#153a5a" }}
          >
            {t(name)}
          </Box>
          <Box sx={{ pt: 5, fontSize: "25px", pb: 3 }}>
            <Typography component="legend">
              {t("Change the review star")}
            </Typography>
            <Rating
              name="simple-controlled"
              precision={0.5}
              value={value}
              sx={{ fontSize: "32px" }}
              onChange={(event, newValue) => {
                setValue(newValue);
              }}
            />
          </Box>
          <TextField
            autoFocus
            id="filled-basic"
            label={t("Review Title*")}
            variant="filled"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            sx={{ width: 2 / 3, mt: 2 }}
          />
          <TextField
            placeholder={t("Provide a brief description*")}
            multiline
            variant="filled"
            rows={8}
            maxRows={8}
            sx={{ width: 2 / 3, mt: 2 }}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          />
          <Box sx={{ py: 3, pt: 4, fontSize: "14px" }}>
            {t("Upload image(s) - maximum 3 images")}
          </Box>
          <input
            type="file"
            onChange={(e) => {
              upload(e.target.files[0]);
            }}
            style={{ width: "300px", cursor: "pointer" }}
          />
          {alert && (
            <Alert sx={{ width: "400px", mt: 2 }} severity="warning">
              {alert}
            </Alert>
          )}
          <Box sx={{ display: "flex" }}>
            {imageUrl && (
              <Box
                sx={{
                  pt: 2,
                  pr: 2,
                  display: "flex",
                  flexDirection: "column",
                  width: "100px",
                  // border: "1px solid black",
                  alignItems: "center",
                  color: "gray",
                }}
              >
                {imageUrl && (
                  <img src={imageUrl} alt="" width="100" height="100" />
                )}
                <Box
                  onClick={() => removeImage(imageUrl)}
                  sx={{ cursor: "pointer", pt: 2, fontSize: "13px" }}
                >
                  {t("Remove")}
                </Box>
              </Box>
            )}

            {imageUrl2 && (
              <Box
                sx={{
                  pt: 2,
                  pr: 2,
                  display: "flex",
                  flexDirection: "column",
                  width: "100px",
                  // border: "1px solid black",
                  alignItems: "center",
                  color: "gray",
                }}
              >
                <img src={imageUrl2} alt="" width="100" height="100" />
                <Box
                  onClick={() => removeImage(imageUrl2)}
                  sx={{ cursor: "pointer", pt: 2, fontSize: "13px" }}
                >
                  {t("Remove")}
                </Box>
              </Box>
            )}
            {imageUrl3 && (
              <Box
                sx={{
                  pt: 2,
                  pr: 2,
                  display: "flex",
                  flexDirection: "column",
                  width: "100px",
                  // border: "1px solid black",
                  alignItems: "center",
                  color: "gray",
                }}
              >
                <img src={imageUrl3} alt="" width="100" height="100" />
                <Box
                  onClick={() => removeImage(imageUrl3)}
                  sx={{ cursor: "pointer", pt: 2, fontSize: "13px" }}
                >
                  {t("Remove")}
                </Box>
              </Box>
            )}
          </Box>
          <Box>
            {/* <button
              // onClick={(e) => submit(e)}
              onClick={handleClickOpen}
              className="custom_btn_withOrangebg"
              style={{ width: "200px", marginTop: "30px", marginRight: "10px" }}
            >
              Delete
            </button> */}
            <button
              onClick={(e) => submit(e)}
              className="custom_btn"
              style={{ width: "200px", marginTop: "30px" }}
            >
              {t("Add")}
            </button>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default DashboardLeaveANewReview;
